export enum CtaType {
  PRIMARY,
  OUTLINE
}

type SelectedElement<T> = { id: number | string; title: string; caption: string; otherElementData?: T }

export type ListElementProps<T = Record<string, unknown>> = {
  id: number | string;
  title: string;
  image?: string
  caption: string;
  otherElementData?: T;
  ctaTitle?: string;
  ctaType: CtaType
  onSelectElement: (elementData: SelectedElement<T>) => void;
}
